import React, { Fragment } from 'react';
import joi from 'joi-browser';
import { Form, Row, Col, Avatar, Button, Icon } from 'antd';
import { connect } from 'react-redux';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';
import PlaceCard from '../Places/components/PlaceCard';
import InfoItem from '../../components/InfoItem';
import {
  getClaimBusinessRequestById,
  updateClaimBusinessRequest,
  resetState,
  resetSuccessSave,
} from '../../modules/places';
import Status from './components/Status';
import { Link } from 'react-router-dom';
import User from '../Clients/components/User';
import FormItem from '../../components/BaseForm/FormItem';
import PlaceList from '../Places/components/List';

class ClaimBusinessRequestForm extends EditForm {
  validationSchema = joi.object({
    id: joi.number().default(null),
    name: joi.string().trim().required(),
    logo: joi.object().when('id', { is: null, then: joi.required() }),
    description: joi.string().trim().required(),
  });

  styles = {
    ...this.styles,
    uploadForm: {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    },
  };

  static getDerivedStateFromProps(props) {
    const { data } = props;

    if (data && data.id) {
      return { data };
    }

    return null;
  }

  renderFormActions(submitLabel, loading) {
    const { isLoading, data } = this.props;
    return (
      <FormItem layout={{ wrapperCol: { span: 24 } }}>
        <Col xs={4} lg={4}>
          <Button className="buttonSubmit"
                  type="primary"
                  onClick={this.goBack}
                  disabled={isLoading}>
            <Icon type="arrow-left" />
            Back
          </Button>
        </Col>
        {data.status === 'pending' ? (
          <Col xs={20} lg={20}>
            <Row type="flex" justify="end">
              <Col>
                <Button
                  className="buttonSubmit"
                  type="danger"
                  onClick={this.onReject}
                  disabled={isLoading}
                >
                  Reject
                </Button>
              </Col>
              <Col style={{ marginLeft: 16 }}>
                <Button
                  className="buttonSubmit"
                  type="primary"
                  onClick={this.onAccept}
                  disabled={isLoading}
                >
                  Accept
                </Button>
              </Col>
            </Row>
          </Col>
        ) : null}
      </FormItem>
    );
  }

  onAccept = () => {
    this.props.onSubmit(this.props.data.id, { status: 'accepted' });
  };

  onReject = () => {
    this.props.onSubmit(this.props.data.id, { status: 'rejected' });
  };

  render() {
    const { data, successSave, error } = this.props;

    return (
      <Layout>
        <Form onSubmit={this.onSubmit}>
          {this.renderFormActions('Save')}
          {successSave && this.renderSuccessAlert('Successfully saved.')}
          {error && this.renderErrorAlert(error)}
          <div className="container-md">
            <Row gutter={16}>
              <Col md={24} lg={14}>
                <InfoItem label="Status"
                          value={<Status status={data.status} />}
                          labelSpan={6}
                          valueSpan={18} />
              </Col>
            </Row>
            <Row gutter={16}>
              <Col md={24} lg={12}>
                <h3>User</h3>
                <User data={data.user} />
              </Col>
              <Col md={24} lg={12}>
                <h3>Claims to own the place</h3>
                <PlaceCard place={data.place} />
              </Col>
            </Row>
            <Row gutter={16}>
              <PlaceList
                data={data.user_places}
                // total={Array.isArray(data.user_places) && data.user_places.length}
                className="grid-list-ib"
              />
            </Row>
          </div>
        </Form>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.places,
    data: state.places.claimBusinessRequests || {},
  }),
  {
    getById: getClaimBusinessRequestById,
    onSubmit: updateClaimBusinessRequest,
    resetState,
    resetSuccessSave,
  })(ClaimBusinessRequestForm);



// WEBPACK FOOTER //
// ./src/containers/ClaimBusiness/ClaimBusinessRequestForm.js